import React, { useState, useEffect } from 'react';
import '../../../css/administration.css'
import '../../../components/layout/layout.css'
import BasicCard from '../../../components/basics/cards/BasicCard'
import FilterSettings from '../../../components/FilterSettings'
import ReportTable from '../../../components/ReportTable'
import ReportDownload from '../../../components/ReportDownload'
import { ErrorService } from '../../../services/ErrorService'
import '../../basicreport/basicReport.css'

function DownloadGlobalScenario() {
    const downloadConfig = {
        idName: 'scenarioID',
        excelFileName: 'GlobalScenarioExcelTemplate.xlsx'
    }

    const controllerName = 'GlobalScenario';
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const pageConfig = {
        controllerName: controllerName,
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        pageSettings: { name: 'Global scenario' },
    }
    const [downloadOptions, setDownloadOptions] = useState({})
    const [selectedDownloadItems, setSelectedDownloadItems] = useState([])
    const [filterArray, setFilterArray] = useState(0)
    const hasDownload = true;

    useEffect(() => {
        setDownloadOptions({ hasDownload: hasDownload, selectedDownloadItems: selectedDownloadItems, setSelectedDownloadItems: setSelectedDownloadItems })
    }, [hasDownload, selectedDownloadItems])

    return (
        <BasicCard cardConfig={{ cardTitle: '', cardHeadingElement: 'h3' }}>
            <span className='basic-report-card'>
                <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} />
                <ReportTable pageConfig={pageConfig} filterArray={filterArray} downloadOptions={downloadOptions} setUpdatingFilter={setUpdatingFilter} />
                <ReportDownload pageConfig={pageConfig} filterArray={filterArray} downloadConfig={downloadConfig} downloadItems={selectedDownloadItems} />
            </span>
        </BasicCard>
    )
}

export default DownloadGlobalScenario